import { headerTabelaResultadosOPSStyles } from './HeaderTabelaResultadosOPS.style'

export function headerTabelaResultadosOPSIO() {
  return {
    styles: headerTabelaResultadosOPSStyles
  }
}
export type HeaderTabelaResultadosOPSIO = ReturnType<typeof headerTabelaResultadosOPSIO>
